export const convertTimestampToLocalDatetime = timestamp => {
    var d = new Date(timestamp * 1000); // The 0 there is the key, which sets the date to the epoch
    return `${d.getFullYear()}. ${d.getMonth() + 1}. ${d.getDate()}`;
}